import _ from "lodash";
import {
    FETCH_INVOICES_REQUEST,
    FETCH_INVOICES_FILTER_REQUEST,
    RECEIVE_INVOICES,
    RECEIVE_INVOICES_FILTER,
    EXPORT_INVOICE_REQUEST, EXPORT_INVOICE_DONE, CLEAR_INVOICE_PAGINATION, SET_ITEMS_OFFSET, SET_FILTERS,
    RESET_INVOICES
} from '../../../constants/index'
import {
    data_download_api_resource
} from '../../../utils/http_functions'
// import {
//     logoutAndRedirect
// } from './auth'
import saveAs from 'file-saver';
import Settings from "../../../settings";
import { i18n } from "../../../config";

export const resetInvoices = () => {
  return {
    type: RESET_INVOICES
  };
}

export const fetchInvoicesRequest = ({
  filter = '',
  offset = 0,
  limit = 100
}) => {

  return {
    type: FETCH_INVOICES_REQUEST,
    payload: {
      filter,
      offset,
      limit
    },
  };
}

export function fetchInvoicesFilterRequest() {
    return {
        type: FETCH_INVOICES_FILTER_REQUEST
    };
}

export function receiveInvoices(response, errors=null) {
    return {
        type: RECEIVE_INVOICES,
        payload: {
            response,
            errors
        },
    };
}

export function receiveInvoicesFilter(payload) {
    return {
        type: RECEIVE_INVOICES_FILTER,
        payload
    };
}

export function changeItemsOffset(newItemsOffset) {
    return {
        type: SET_ITEMS_OFFSET,
        payload: {
            itemsOffset: newItemsOffset
        }
    }
} 

export function changeFilter(newFilters, newItemsPage, newItemsOffset) {
    return {
        type: SET_FILTERS,
        payload: {
            itemsPage: newItemsPage,
            itemsOffset: newItemsOffset,
            currentFilter: newFilters
        }
    }
} 

export function clearPagination() {
    return async (dispatch) => {
        dispatch({
            type: CLEAR_INVOICE_PAGINATION
        });
    }
} 

export function exportInvoiceRequest(invoice) {
    return {
        type: EXPORT_INVOICE_REQUEST,
        payload: {
            invoice,
            message: null,
        },
    };
}

export function exportInvoiceDone(invoice) {
    return {
        type: EXPORT_INVOICE_DONE,
        payload: {
            invoice
        },
    };
}

export function exportInvoice(token, invoice, report_type) {
    return (dispatch) => {
        dispatch(exportInvoiceRequest(invoice));
        if (_.get(Settings, "invoices.downloadInNewTab", false)) {
            let newTab = window.open(i18n.t('common:url.loading'), '_blank');
            return data_download_api_resource(token, `invoices/${invoice}/${report_type}/`, 1)
                .then(response => response.data)
                .then(blob => URL.createObjectURL(blob))
                .then(anUrl => {
                    newTab.location.href = anUrl;
                    URL.revokeObjectURL(i18n.t('common:url'));
                })
                .catch(error => {
                    // if (error.status === 401) {
                    //     dispatch(logoutAndRedirect(error));
                    // }
                })
                .finally(() => {
                    dispatch(exportInvoiceDone(invoice));
                });
        } else {
            return data_download_api_resource(token, `invoices/${invoice}/${report_type}/`, 1)
              .then(response => {
                  const filename = response.headers["content-disposition"].split("=");
                  saveAs(response.data, filename[1]);
              })
              .catch(error => {
                //   if (error.status === 401) {
                //       dispatch(logoutAndRedirect(error));
                //   }
              })
              .finally(() => {
                  dispatch(exportInvoiceDone(invoice));
              });
        }
    };
}

export function exportInvoiceHistoric(token, invoice) {
  return (dispatch) => {
      dispatch(exportInvoiceRequest(invoice));
      if (_.get(Settings, "invoices.downloadInNewTab", false)) {
          let newTab = window.open(i18n.t('common:url.loading'), '_blank');
          return data_download_api_resource(token, `invoices/historic/${invoice}/`, 2)
              .then(response => response.data)
              .then(blob => URL.createObjectURL(blob))
              .then(anUrl => {
                  newTab.location.href = anUrl;
                  URL.revokeObjectURL(i18n.t('common:url'));
              })
              .finally(() => {
                  dispatch(exportInvoiceDone(invoice));
              });
      } else {
          data_download_api_resource(token, `invoices/historic/${invoice}/`, 2)
            .then(response => {
                const filename = response.headers["content-disposition"].split("=");
                saveAs(response.data, filename[1]);
            })
            .finally(() => {
                dispatch(exportInvoiceDone(invoice));
            });
      }
  };
}
